import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";

export const customHomePageGuard: CanActivateFn = (route, state): false => {
    const router: Router = inject(Router);
    router.navigateByUrl(localStorage.getItem('homeIsFeed') ? '/feed' : '/dashboard');
    return false;
};
